<template>

  <section class="error">
    <h1 class="error__title">Whoops, #404</h1>
    <h2 class="error__subtitle">It looks like there’s<br>nothing here...</h2>
    <div class="error__scroller" @click="scrollToPortfolio()">This way for Portfolio</div>
  </section>

</template>

<script>

  export default {
    name: 'Error',
    methods: {
      scrollToPortfolio() {
        document.querySelector('.list').scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
  }

</script>

<style scoped lang="scss">

  @import '@/scss/app.scss';

  .error {
    @include container;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 20px;
    padding-top: 70px;
    margin-bottom: 40px;

    @include mq(small) {
      height: 100vh;
      justify-content: flex-end;
      padding-top: 90px;
    }
  }

  .error__title {
    @include outline;
    margin-bottom: 20px;
    z-index: 1;

    br {
      display: none;

      @include mq(small) {
        display: block;
      }
    }
  }

  .error__subtitle {
    @include title;
    margin-bottom: 110px;
    
    @include mq(small) {
      margin-bottom: 50px;
    }
  }

  .error__scroller {
    @include current(small);
    cursor: pointer; 
    line-height: 40px;
    padding-bottom: 10px;
    padding-left: 60px;
    padding-top: 10px;
    position: relative;

    &:before {

      @keyframes scrollAnimation {
        0%, 100% {
          top: 0px;
        }

        50% {
          top: 20px;
        }
      }

      content: '';
      position: absolute;
      left: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      top: 0px;
      background: url('../assets/arrow.svg') 50% 50% no-repeat $dark;
      animation: scrollAnimation 2s ease-in-out infinite;
    }

    .portfolio & {
      position: absolute;
      bottom: 0;
      left: 0;

      @include mq(small) {
        position: relative;
      }
    }
  }

</style>
